var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"applyform"},[_c('enterApplyForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }